import React from "react"
import {Box, Modal, Paper, Typography, Button} from "@mui/material"
import styled from "styled-components"

type ResetExtensionConfirmModalProps = {
	open: boolean
	onClose: () => void
	onConfirm: () => void
}

const ResetExtensionConfirmModal = ({open, onClose, onConfirm}: ResetExtensionConfirmModalProps) => {
	return (
		<Modal
			open={open}
			onClose={onClose}
			aria-labelledby="reset-extension-confirm-modal"
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<StyledPaper>
				<TextContainer>
					<Typography variant="h6" align="center" gutterBottom>
						Confirm extension reset
					</Typography>
					<Typography variant="body2" align="center" color="textSecondary">
						Are you sure you want to reset the active extension? This will restore the customer&apos;s
						instalment caps to the original limits.
					</Typography>
				</TextContainer>

				<ButtonContainer>
					<StyledConfirmButton variant="contained" fullWidth onClick={onConfirm}>
						YES, RESET TO DEFAULT
					</StyledConfirmButton>
					<StyledCancelButton variant="contained" fullWidth onClick={onClose}>
						GO BACK
					</StyledCancelButton>
				</ButtonContainer>
			</StyledPaper>
		</Modal>
	)
}

// Styled Components
const StyledPaper = styled(Paper)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 90%;
	max-width: 480px;
	padding: 32px;
	outline: none;
	border-radius: 12px;
	box-shadow:
		0px 16px 36px -20px rgba(0, 6, 46, 0.2),
		0px 16px 64px 0px rgba(0, 0, 85, 0.02),
		0px 12px 60px 0px rgba(0, 0, 0, 0.15);
	display: flex;
	flex-direction: column;
	gap: 24px;
`

const TextContainer = styled(Box)`
	display: flex;
	flex-direction: column;
	gap: 12px;
`

const ButtonContainer = styled(Box)`
	display: flex;
	flex-direction: column;
	gap: 12px;
`

const StyledConfirmButton = styled(Button)`
	background-color: #474cde;
	color: white;
	text-transform: uppercase;
	font-weight: 500;
	font-size: 14px;
	letter-spacing: 0.4px;
	height: 40px;
	border-radius: 6px;

	&:hover {
		background-color: #3a3fb8;
	}
`

const StyledCancelButton = styled(Button)`
	background-color: #e9eaeb;
	color: #717680;
	text-transform: uppercase;
	font-weight: 500;
	font-size: 14px;
	letter-spacing: 0.4px;
	height: 40px;
	border-radius: 6px;

	&:hover {
		background-color: #d5d7da;
	}
`

export {ResetExtensionConfirmModal}
export type {ResetExtensionConfirmModalProps}
